import { render, staticRenderFns } from "./Nilai.vue?vue&type=template&id=aebdeacc&scoped=true&"
import script from "./Nilai.vue?vue&type=script&lang=ts&"
export * from "./Nilai.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aebdeacc",
  null
  
)

export default component.exports